import React, {useMemo, useState} from "react";
import Notification, {iconTypeMapper} from "./Notification"
import classNames from "classnames";
import buttonStyles from "../buttons.module.scss";
import {ReactComponent as Close} from "../../images/monochrome-icons/ic-close.svg";
import AnimateHeight from "react-animate-height";
import styles from "./Notification.module.scss";

const values = {
    error: 4,
    warning: 3,
    info: 2,
    success: 1
};

const compare = (type1, type2) => {
    const val1 = values[type1] || 0;
    const val2 = values[type2] || 0;

    return val2 > val1 ? type2 : type1;
};

const SingleNotification = ({type, moreInfo, description, onClose}) => {
    const Icon = iconTypeMapper[type].icon;
    return <>
        <Icon className={classNames(styles["type-icon"], styles[type])}/>
        <div>
            {moreInfo} {description}
        </div>
        <div>
            {onClose && <button type="button" className={styles["delete"]} onClick={onClose}>
                <Close/>
            </button>}
        </div>
    </>
};

const GroupedNotifications = ({maxType, notifications, className, style}) => {
    const [showAll, setShowAll] = useState(false);
    const Icon = iconTypeMapper[maxType].icon;
    return <AnimateHeight
        duration={ 400 }
        easing="cubic-bezier(.25,.8,.25,1)"
        height={ showAll ? "auto" : 67 }
        className={classNames(styles["grouped-container"], className)}
        style={style}
    >
        <>
            {!showAll &&    <div className={classNames(styles["container"], styles[maxType])}>
                <div className={styles["main"]}>
                    <Icon className={styles["type-icon"]}/>
                    <div>
                        You have {notifications.length} new notifications.
                        <button type="button" onClick={() => setShowAll(true)} className={classNames(buttonStyles["text"], styles["show-more"])}>
                            See Details
                        </button>
                    </div>
                </div>
            </div>}
            {showAll && <div className={styles['active-grouped-container']}>
                {notifications.map((notification, index) => {
                    return <SingleNotification key={index} {...notification}/>
                })}
            </div>}
        </>
    </AnimateHeight>

};

export default ({notifications: _notifications, className, style, isGlobal}) => {
    const {notifications, maxType} = useMemo(() => {
        const notifications = (_notifications || []).filter(notification => notification && notification.type);
        let maxType = null;
        notifications.forEach(({type}) => {
            maxType = compare(maxType, type);
        });

        return {notifications, maxType}
    }, [_notifications]);

    const _className = classNames(className, {[styles['global']]: isGlobal});

    if(notifications.length === 0) {
        return ""
    } else if (notifications.length < 4) {
        return <div className={_className} style={style}>
            {notifications.map((notification, index) => {
                return <Notification key={notification.notificationId || index} {...notification}>
                    {notification.description}
                </Notification>
            })}
        </div>
    } else {
        return <GroupedNotifications maxType={maxType} notifications={notifications} className={_className} style={style}/>
    }
};
